var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":_vm.navList[1].img,"alt":""}}),_c('div',{staticClass:"btn-group"},[_c('div',{staticClass:"btn primary",on:{"click":_vm.handlePrimaryClick}},[_vm._v("立即办理")]),_c('div',{staticClass:"btn secondary",on:{"click":_vm.handleSecondaryClick}},[_vm._v("火化证明")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }